<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';
	//Types
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	let localIp = get_local_ip(device.id);

	let ledStatusChecked = $settingsStore.led_status_disable;
	let loadingStatus = false;

	let ledPowerChecked = $settingsStore.led_power_disable;
	let loadingPower = false;

	const sentRequestLedStatus = async (e: InputClickEvent) => {
		loadingStatus = true;
		let saveLedStatusRes;
		ledStatusChecked = e.target.checked;

		if (localIp) {
			saveLedStatusRes = await localReq(device, `${localIp}/settings`, 'post', {
				led_status_disable: ledStatusChecked,
			});
		} else {
			saveLedStatusRes = await postReq(`/device/settings/led_status_disable`, {
				id: device.id,
				enabled: ledStatusChecked ? 1 : 0,
			});
		}

		if (typeof saveLedStatusRes !== 'undefined' && saveLedStatusRes.isok) {
			settings.led_status_disable = ledStatusChecked;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: !ledStatusChecked
					? $format('led_light_enabled_scc_toast')
					: $format('led_light_disabled_scc_toast') ||
						`Led status light was ${!ledStatusChecked ? 'enabled' : 'disabled'}.`,
			});
		} else {
			ledStatusChecked = !ledStatusChecked;
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loadingStatus = false;
	};

	const sentRequestLedPower = async (e: InputClickEvent) => {
		loadingPower = true;
		let saveLedPowerRes;
		ledPowerChecked = e.target.checked;

		if (localIp) {
			saveLedPowerRes = await localReq(device, `${localIp}/settings`, 'post', {
				led_power_disable: ledPowerChecked,
			});
		} else {
			saveLedPowerRes = await postReq(`/device/relay/settings/led_options`, {
				id: device.id,
				channel: '',
				setled: 'power',
				disable: ledPowerChecked ? 1 : 0,
			});
		}
		if (typeof saveLedPowerRes !== 'undefined' && saveLedPowerRes.isok) {
			settings.led_power_disable = ledPowerChecked;
			devices_settings.update_devices_settings(device.id, settings);
			toast.open({
				type: 'success',
				title: ledPowerChecked
					? $format('power_on_light_disabled_scc_toast')
					: $format('power_on_light_enable_scc_toast') ||
						`Power on state light was ${!ledPowerChecked ? 'enabled' : 'disabled'}.`,
			});
		} else {
			ledPowerChecked = !ledPowerChecked;
			toast.open({ type: 'danger', title: $format('error_global') });
		}

		loadingPower = false;
	};
</script>

<Toggle
	size="m"
	disabled={loadingStatus}
	checked={ledStatusChecked}
	on:click={sentRequestLedStatus}
	id="toggle-tfztxgj"
>
	{$format('device_wi_fi_led_description', {
		default: 'Disable wifi status led.',
	})}
</Toggle>

{#if device?.type !== 'SHPLG2-1'}
	<Toggle
		size="m"
		disabled={loadingPower}
		checked={ledPowerChecked}
		on:click={sentRequestLedPower}
		id="toggle-oy5gdcm"
	>
		{$format('device_power_on_light_description', {
			default: 'Disable power on state light.',
		})}
	</Toggle>
{/if}
